import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { PlgApi } from './apis/plg-api';
import { PlgApiImpl } from './apis/impls/plg-api';
import { PlgInviteApi } from './apis/plg-invite-api';
import { PlgInviteApiImpl } from './apis/impls/plg-invite-api';

export const plgContainer = new ContainerModule(bind => {
    bind(PlgApi).to(PlgApiImpl);
    bind(PlgInviteApi).to(PlgInviteApiImpl);
});

// 导出类型和 API Symbol
export { PlgApi } from './apis/plg-api';
export { PlgInviteApi } from './apis/plg-invite-api';
export * from './types';
